import React, { useState } from 'react'
import { enviarDenunciaPublica } from "../api/formulariosPublicos";

const TIPOS_PERMITIDOS = ['image/jpeg', 'image/png', 'image/webp'];
const TAMANIO_MAXIMO = 500 * 1024; // 500 KB, igual que el contrato del backend

const CAMPOS_TEXTO_DENUNCIA = [
  'email',
  'telefono',
  'direccion',
  'localidad',
  'direccionlugar',
  'entrecalles',
  'pagina',
  'redsocial',
  'otro',
];

function validarArchivo(file) {
  if (!file) return null;
  if (!TIPOS_PERMITIDOS.includes(file.type)) {
    return 'Formato no permitido. Usá JPG, PNG o WEBP.';
  }
  if (file.size > TAMANIO_MAXIMO) {
    return 'El archivo supera los 500 KB permitidos.';
  }
  return null;
}

function Denuncias() {
  const [files, setFiles] = useState([null, null]);
  const [fileErrors, setFileErrors] = useState([null, null]);
  const [formValues, setFormValues] = useState({
    email: '',
    direccion: '',
    localidad: '',
    telefono: '',
    asistiallugar: false,
    aposte: false,
    recibicomprobante: false,
    direccionlugar:'',
    entrecalles:'',
    pagina:'',
    redsocial:'',
    otro:'',
  });

  const [sending, setSending] = useState(false); // State to track sending status
  const [estado, setEstado] = useState(null); // { tipo: 'exito' | 'error', mensaje: string }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;

    // Validación de archivos ya elegidos (por si quedó un error sin corregir).
    if (fileErrors[0] || fileErrors[1]) {
      setEstado({ tipo: 'error', mensaje: 'Revisá las fotos adjuntas: ' + [fileErrors[0], fileErrors[1]].filter(Boolean).join(' ') });
      return;
    }

    // Regla de contenido mínimo (espejo del backend): no todo vacío y sin fotos.
    const hayTexto = CAMPOS_TEXTO_DENUNCIA.some((campo) => formValues[campo] && formValues[campo].trim() !== '');
    const hayFotos = Boolean(files[0] || files[1]);
    if (!hayTexto && !hayFotos) {
      setEstado({ tipo: 'error', mensaje: 'Completá al menos un dato o adjuntá una foto antes de enviar.' });
      return;
    }

    try {
      setSending(true);
      setEstado(null);

      const respuesta = await enviarDenunciaPublica(formValues, {
        fotoLugar: files[0],
        fotoSitio: files[1],
      });

      setSending(false);
      setEstado({
        tipo: 'exito',
        mensaje: respuesta?.avisoEnviado === false
          ? 'Tu denuncia fue registrada correctamente.'
          : 'Tu denuncia fue registrada correctamente. Gracias por colaborar.',
      });
      setFormValues({
        email: '',
        direccion: '',
        localidad: '',
        telefono: '',
        asistiallugar: false,
        aposte: false,
        recibicomprobante: false,
        direccionlugar: '',
        entrecalles: '',
        pagina: '',
        redsocial: '',
        otro: '',
      });
      setFiles([null, null]);
      setFileErrors([null, null]);

      // Recién con la confirmación del servidor se redirige, y se le da tiempo al usuario a leerla.
      setTimeout(() => {
        window.location.href = 'https://www.inprojuy.gob.ar';
      }, 3000);
    } catch (error) {
      console.error(error);
      setEstado({ tipo: 'error', mensaje: error.message || 'Error al enviar la denuncia. Inténtalo de nuevo.' });
      setSending(false);
    }
  };


  const handleFileChange = (e, index) => {
    const file = e.target.files[0] || null;
    const error = validarArchivo(file);

    const newFiles = [...files];
    newFiles[index] = error ? null : file;
    setFiles(newFiles);

    const newErrors = [...fileErrors];
    newErrors[index] = error;
    setFileErrors(newErrors);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value;
    setFormValues(prevValues => ({
      ...prevValues,
      [name]: fieldValue
    }));
  };

  return (
    <div className='fondotransparente container'>
        <center><h2 className='botonbordeazul text-white px-5 py-3 mb-4'>Denuncias</h2></center>
        <p>Lo invitamos a completar el siguiente formulario ingresando la mayor cantidad posible de datos, y completando los campos obligatorios. </p>
 <p>El sistema de denuncias contra el juego clandestino del INPROJUY ha sido creado para que usted pueda canalizar las denuncias de manera anónima, asegurando la máxima confidencialidad.</p>
 <p><small>Las fotos que adjuntes se almacenarán en nuestros servidores para el seguimiento de la denuncia.</small></p>

          <form  onSubmit={handleSubmit} className="contactform row g-3 mt-4">
        <div className='col-md-12 m-0 p-0'>
          <label className="h5 form-label">Correo Electrónico</label>
          <input type="email" className=" form-control border px-3 py-2 rounded placeholder-gray-500" id="exampleInputEmail1" aria-describedby="emailHelp" name ='email' value={formValues.email} onChange={handleChange}/>
          <label className="h5 form-label">Teléfono</label>
          <input type="tel" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='telefono' value={formValues.telefono} onChange={handleChange} />
          <label className="h5 form-label">Dirección</label>
          <input type="text" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='direccion' value={formValues.direccion} onChange={handleChange} />
          <label className="h5 form-label">Localidad</label>
          <input type="text" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='localidad'value={formValues.localidad} onChange={handleChange}/>
        </div>
        <div className="mb-3 form-check">
          <input type="checkbox" className="form-check-input" id="exampleCheck1" name ='asistiallugar' checked={formValues.asistiallugar} onChange={handleChange} />
          <label className="form-check-label" htmlFor="exampleCheck1">Asistí al lugar</label>
        </div>
        <div className="mb-3 form-check">
          <input type="checkbox" className="form-check-input" id="exampleCheck2" name ='aposte' checked={formValues.aposte} onChange={handleChange}/>
          <label className="form-check-label" htmlFor="exampleCheck2">Aposté</label>
        </div>
        <div className="mb-3 form-check">
          <input type="checkbox" className="form-check-input" id="exampleCheck3" name ='recibicomprobante' checked={formValues.recibicomprobante} onChange={handleChange}/>
          <label className="form-check-label" htmlFor="exampleCheck3">Recibí un comprobante</label>
        </div>
        <div className='col-md-12 m-0 p-0'>
        <label className="h5 form-label">Dirección del lugar</label>
        <input type="text" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='direccionlugar' value={formValues.direccionlugar} onChange={handleChange}/>
        <label className="h5 form-label">Entre calles/ Interseccion calle</label>
        <input type="text" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='entrecalles'value={formValues.entrecalles} onChange={handleChange}/>
        <div className="input-group col-md-12 m-0">
          <label className="h5 col-md-12 form-label">Foto del lugar (JPG, PNG o WEBP, hasta 500 KB, opcional)</label>

          <input type='file' accept="image/jpeg,image/png,image/webp" className="form-control  my-3 border px-3 py-2 rounded placeholder-gray-500" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload"  onChange={(e) => handleFileChange(e, 0)} />
          {fileErrors[0] && <div className="text-danger small mb-2" role="alert">{fileErrors[0]}</div>}
        </div>
        <label className="h5 form-label">EN LINEA:</label>
        <br/>
        <label className="h5 form-label">Pagina web</label>
        <input type="text" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='pagina' value={formValues.pagina} onChange={handleChange}/>
        <label className="h5 form-label">Red Social</label>
        <input type="text" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='redsocial' value={formValues.redsocial} onChange={handleChange} />
        <label className="h5 form-label">Otro</label>
        <input type="text" className=" form-control border px-3 py-2 rounded placeholder-gray-500" name ='otro' value={formValues.otro} onChange={handleChange} />
        <div className="input-group">
          <label className="h5 col-md-12 form-label">Foto del sitio (JPG, PNG o WEBP, hasta 500 KB, opcional)</label>
          <input type="file" accept="image/jpeg,image/png,image/webp" className=" form-control  my-3 border px-3 py-2 rounded placeholder-gray-500" id="inputGroupFile05" aria-describedby="inputGroupFileAddon05" aria-label="Upload" onChange={(e) => handleFileChange(e, 1)} />
          {fileErrors[1] && <div className="text-danger small mb-2" role="alert">{fileErrors[1]}</div>}
        </div>
        {estado && (
          <div className="col-12 m-0" aria-live="polite">
            <div className={estado.tipo === 'exito' ? 'alert alert-success' : 'alert alert-danger'} role={estado.tipo === 'error' ? 'alert' : 'status'}>
              {estado.mensaje}
            </div>
          </div>
        )}
        <button className="btn btn-primary mt-4" type="submit" disabled={sending}>
          {sending ? "Enviando..." : "Subir Formulario"}
        </button>
</div>
      </form>
    </div>
  );
}

export default Denuncias
